// extracted by mini-css-extract-plugin
export var icon = "linkColorTile-module--icon--03584";
export var iconBox = "linkColorTile-module--iconBox--3ae56";
export var title = "linkColorTile-module--title--25072";